import {connect} from 'react-redux'
import {Text, Group, Image} from 'react-konva'
import {initialize} from 'redux-form'
import * as actTableManagement from 'actions/tableManagement'
import {COL_MAX, ROW_MAX, GRID_SIZE} from './constants'

const getIndex = (col, row) => { // 1-based index
  return (row * COL_MAX) + col + 1
}
const IMAGE_INDEX = 0
const EDIT_TEXT_INDEX = 2
const DELETE_TEXT_INDEX = 3

class RestoTable extends React.Component {
  render () {
    const {table} = this.props
    let i = table.rowNum
    let j = table.columnNum
    let xx = j * GRID_SIZE
    let yy = i * GRID_SIZE
    return (<Group
      x={0 + xx} y={0 + yy}
      draggable='true'
      onDragEnd={(e) => this._dragEnd(e, table)}
      onDragStart={this._dragStart}
      onDragMove={this._dragMove}
      onMouseOver={this._mouseOverTable}
      onMouseOut={this._mouseOutTable}
      theTable={table}
      dragBoundFunc={this._dragBound}
    >
      <Image
        x={10} y={10} width={100} height={100}
        zIndex={1}
        image={table.shape === 'Circle' ? this.props.imageRound : this.props.imageSquare}
      />

      <Text
        zIndex={2}
        x={10} y={35} width={100}
        fontFamily='Arial' fontSize={12}
        text={`${table.name}\n${table.maxPax} pax`}
        fill='black' align='center'
      />
      <Text
        zIndex={2}
        x={40} y={65} width={40}
        fontFamily='Arial' fontSize={12}
        text={`Edit`}
        fill='blue' align='center'
        visible={false}
        onClick={(e) => this._clickEdit(e, table)}
        onMouseOver={this._mouseOverText}
        onMouseOut={this._mouseOutText}
        shadowColor='gray'
        shadowBlur={0}
      />
      <Text
        zIndex={3}
        x={40} y={80} width={40}
        fontFamily='Arial' fontSize={12}
        text={`Delete`}
        fill='red' align='center'
        visible={false}
        onClick={(e) => this._clickDelete(e, table)}
        onMouseOver={this._mouseOverText}
        onMouseOut={this._mouseOutText}
        shadowColor='gray'
        shadowBlur={0}
      />
    </Group>)
  }

  _dragBound = (pos, e) => {
    const maxY = 500
    const maxX = 730
    let newY = (pos.y > maxY) ? maxY : (pos.y < 0) ? 0 : pos.y
    let newX = (pos.x > maxX) ? maxX : (pos.x < -10) ? -10 : pos.x
    return {
      x: newX,
      y: newY
    }
  }

  _mouseOverText = (e) => {
    e.target.setAttr('shadowBlur', 1)
    e.target.parent.parent.draw()
    e.target.parent.parent.parent.container().style.cursor = 'pointer'
  }

  _mouseOutText = (e) => {
    e.target.setAttr('shadowBlur', 0)
    e.target.parent.parent.draw()
    e.target.parent.parent.parent.container().style.cursor = 'default'
  }

  _mouseOverTable = (e) => {
    e.target.parent.children[IMAGE_INDEX].setAttr('shadowBlur', 1)
    e.target.parent.children[EDIT_TEXT_INDEX].setAttr('visible', true)
    e.target.parent.children[DELETE_TEXT_INDEX].setAttr('visible', true)
    e.target.parent.parent.draw()
  }

  _mouseOutTable = (e) => {
    e.target.parent.children[IMAGE_INDEX].setAttr('shadowBlur', 0)
    e.target.parent.children[EDIT_TEXT_INDEX].setAttr('visible', false)
    e.target.parent.children[DELETE_TEXT_INDEX].setAttr('visible', false)
    e.target.parent.parent.draw()
  }

  _clickEdit = (e, tableObj) => {
    const {dispatch} = this.props
    dispatch(actTableManagement.setTable(tableObj))
    dispatch(initialize('editTableModal', {
      id: tableObj.id,
      shape: tableObj.shape,
      maxPax: tableObj.maxPax,
      name: tableObj.name,
      rowNum: tableObj.rowNum,
      columnNum: tableObj.columnNum,
      oldName: tableObj.name
    }))
    dispatch(actTableManagement.openEditTableModal())
  }

  _clickDelete = (e, tableObj) => {
    const {dispatch} = this.props
    dispatch(actTableManagement.setTable(tableObj))
    dispatch(actTableManagement.showTableMapDeleteModal())
  }

  _dragStart = (e) => {
    e.target.setZIndex(100) // Bring to front
  }

  _dragMove = (e) => {
  }

  _dragEnd = async (e, tableObj) => {
    const {tables, originalTables} = this.props.map
    const {dispatch} = this.props
    const { x, y } = e.target.attrs
    const newCol = Math.floor(Math.abs(x + 10) / GRID_SIZE)
    const newRow = Math.floor(Math.abs(y + 10) / GRID_SIZE)

    let idx = getIndex(newCol, newRow)

    e.target.setZIndex(idx - 1)

    let row = tableObj.rowNum // original column & row
    let col = tableObj.columnNum

    if ((x < -10) || (y < -10) || (x > ((COL_MAX - 1) * GRID_SIZE) + 10) || (y > ((ROW_MAX - 1) * GRID_SIZE) + 10)) { // out of screen
      e.target.to({ x: col * GRID_SIZE, y: row * GRID_SIZE, duration: 0 })
      return
    }

    const modX = Math.abs(x % GRID_SIZE)
    const modY = Math.abs(y % GRID_SIZE)
    if ((modX > 10 && modX < 110) || (modY > 10 && modY < 110)) { // offset exceeded - i.e. table intersect gridlines
      e.target.to({ x: col * GRID_SIZE, y: row * GRID_SIZE, duration: 0 })
      return
    }

    let index = await tables.findIndex(table => table.columnNum === newCol && table.rowNum === newRow)
    if (index !== -1) {
      e.target.to({ x: col * GRID_SIZE, y: row * GRID_SIZE, duration: 0 })
    } else {
      let index2 = await tables.findIndex(table => table.columnNum === tableObj.columnNum && table.rowNum === tableObj.rowNum)
      if (index2 !== -1) {
        tables[index2].rowNum = newRow
        tables[index2].columnNum = newCol
      }
      e.target.to({ x: newCol * GRID_SIZE, y: newRow * GRID_SIZE, duration: 0 })
    }
    dispatch(actTableManagement.updateSaveLayoutButton(tables, originalTables))
    dispatch(actTableManagement.setTables(tables))
  }
}

function mapStateToProps (state) {
  return {
    map: state.tableManagement.map,
    group: state.tableManagement.group
  }
}

export default connect(mapStateToProps)(RestoTable)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementMap/RestoTable.js